import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Este pack me salvó. Tenía 10 cursos distintos y no sabía cómo armar algo coherente. Ahora sigo los tomos y los chicos están súper enganchados.',
    initials: 'MG',
    name: 'María G.',
    location: 'Docente de Música, Primaria 🇦🇷'
  }, {
    quote: 'Las rúbricas de evaluación son excelentes. Siempre me costó poner nota en arte/música de forma objetiva, esto me facilitó muchísimo el trabajo a fin de trimestre.',
    initials: 'JP',
    name: 'Juan P.',
    location: 'Profesor de Secundaria 🇲🇽'
  }, {
    quote: 'La integración de historia de la música con la práctica instrumental es genial. Mis alumnos de 5to grado armaron un ensamble hermoso gracias a las guías.',
    initials: 'CL',
    name: 'Carolina L.',
    location: 'Docente de Música 🇨🇴'
  }, {
    quote: 'Por $19 USD es un regalo. Solo con el banco de canciones y las actividades de ritmo ya recuperé la inversión. Muy recomendado para profes nuevos.',
    initials: 'DR',
    name: 'Diego R.',
    location: 'Profesor de Música 🇨🇱'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-144">
      <div className="max-w-6xl mx-auto" data-id="element-145">
        <div className="text-center mb-16" data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-147">
            Lo que dicen los docentes de Música.
          </h2>
          <div className="flex items-center justify-center gap-2 text-brand-gray font-medium" data-id="element-148">
            <div className="flex gap-0.5" data-id="element-149">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-150" />)}
            </div>
            <span data-id="element-151">4.9/5 &middot; +300 Docentes</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-152">
          {testimonials.map((t, i) => <div key={i} className="bg-[#fdfaf6] rounded-3xl p-8 flex flex-col h-full border border-brand-creamDark/50" data-id="element-153">
              <div className="flex gap-0.5 mb-6" data-id="element-154">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-155" />)}
              </div>
              <p className="text-brand-text font-medium mb-8 flex-1 leading-relaxed text-lg" data-id="element-156">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-157">
                <div className="w-10 h-10 rounded-full bg-brand-red text-white flex items-center justify-center font-bold text-sm shrink-0" data-id="element-158">
                  {t.initials}
                </div>
                <div data-id="element-159">
                  <p className="font-bold text-brand-text text-sm" data-id="element-160">{t.name}</p>
                  <p className="text-xs text-brand-gray" data-id="element-161">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}